import { createOptionsFrom } from "@/lib/common/Option";

export const SearchOptionsSetLabels = {
	Wtr: "Welcome to Rathe",
	Arc: "Arcane Rising",
	Cru: "Crucible of War",
	Mon: "Monarch",
	Ele: "Tales of Aria",
	Evr: "Everfest",
	Upr: "Uprising",
	Dyn: "Dynasty",
	Out: "Outsiders",
	Dtd: "Dusk till Dawn",
	Evo: "Bright Lights",
	Hvy: "Heavy Hitters",
	Mst: "Part the Mistveil",
	Ros: "Rosetta",
	Hnt: "The Hunted",
	Sea: "High Seas",
	Mpg: "Mastery Pack Guardian",
	Sup: "Super Slam",
	Pen: "Compendium of Rathe",
	Anq: "Antiquity Pack",
	Omn: "Omens of the Third Age",
	Mpw: "Mastery Pack Warrior",
	Iar: "Usurp the Shadow Throne"
} as const;

export type SearchOptionsSet = keyof typeof SearchOptionsSetLabels;

export const SearchOptionsSetOptions = createOptionsFrom(SearchOptionsSetLabels);
